import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';

import {
  AdLabel,
  AdInfoLabel,
  PlacementGradient,
  PlacementHeadline,
  PlacementDescription,
  PlacementAction,
  Rating,
} from '../shared-components';
import { PlayIcon } from '../shared-components/icons';
import { PlacementCard } from './ad-placement-card';

export const ImageAdPlacementBase = ({
  placementData,
  customClassName,
  imagePreviewHeight,

  showShortHeadline,
  shortHeadline,
  isMultiLineShortHeadline,

  showLongHeadline,
  longHeadline,
  isMultiLineLongHeadline,

  finalUrl,

  showDescription,
  description,
  isMultiLineDescription,

  showCallToAction,
  callToAction,

  showAdLabel,
  showGradient,

  showAdInfoLabel,
  isAdInfoLabelWithText,

  showRating,
  ratingPoint,
  maxPoint,
  showRatingPoint,
  ratingComment,

  showPlayIcon,

  i18n,
  classes,
}) => {
  const { placementMeta, imageMeta } = placementData || {};
  const { previewHeight, aspectRatio } = placementMeta || {};
  if (!placementData || !imageMeta) {
    return null;
  }

  const finalImagePreviewHeight =
    imagePreviewHeight > 0 ? imagePreviewHeight : previewHeight;

  return (
    <PlacementCard
      url={finalUrl}
      placementCardClassName={classnames(
        classes.placementCard,
        customClassName
      )}
    >
      <div className={classnames(classes.placementImageContainer)}>
        {showGradient && <PlacementGradient gradientClassName={classes.placementGradient} />}
        {imageMeta.url && (
          <CroppedImageView
            resizeImageHeight={finalImagePreviewHeight}
            aspectRatio={aspectRatio}
            src={imageMeta.url}
            originalWidth={imageMeta.originalWidth}
            originalHeight={imageMeta.originalHeight}
          />
        )}
      </div>
      <div
        className={classnames(classes.placementTextContainer, 'text-container')}
      >
        {showShortHeadline && (
          <PlacementHeadline
            headlineText={shortHeadline}
            isMultiLine={isMultiLineShortHeadline}
            placementHeadlineClassName={classnames(
              classes.placementShortHeadline,
              'short-headline'
            )}
          />
        )}
        {showLongHeadline && (
          <PlacementHeadline
            headlineText={longHeadline}
            isMultiLine={isMultiLineLongHeadline}
            placementHeadlineClassName={classnames(
              classes.placementLongHeadline,
              'long-headline'
            )}
          />
        )}
        {showDescription && (
          <PlacementDescription
            description={description}
            isMultiLine={isMultiLineDescription}
            placementDescriptionClassName={classnames(
              classes.placementDescription,
              'description'
            )}
          />
        )}
        {showRating && (
          <Rating
            i18n={i18n}
            ratingPoint={ratingPoint}
            maxPoint={maxPoint}
            showRatingPoint={showRatingPoint}
            commentText={ratingComment}
          />
        )}
        {showAdLabel && (
          <AdLabel i18n={i18n} adsLabelClassName={classes.placementAdsLabel} />
        )}
        {showAdInfoLabel &&
          <AdInfoLabel adInfoLabelClassName={classes.adInfoLabel} showAdText={isAdInfoLabelWithText} />}
        {showCallToAction &&
          callToAction && (
            <PlacementAction
              actionText={callToAction.replace(/([A-Z])/g, ' $1')}
              placementActionClassName={classes.placementCallToAction}
            />
          )}
        {showPlayIcon && (
          <div
            className={classnames(
              classes.playIconContainer,
              'play-icon-container'
            )}
          >
            <PlayIcon />
          </div>
        )}
      </div>
    </PlacementCard>
  );
};

ImageAdPlacementBase.propTypes = {
  placementData: PropTypes.shape({}).isRequired,
  customClassName: PropTypes.string,
  imagePreviewHeight: PropTypes.number,

  showShortHeadline: PropTypes.bool,
  shortHeadline: PropTypes.string,
  isMultiLineShortHeadline: PropTypes.bool,

  showLongHeadline: PropTypes.bool,
  longHeadline: PropTypes.string,
  isMultiLineLongHeadline: PropTypes.bool,

  finalUrl: PropTypes.string,

  showDescription: PropTypes.bool,
  description: PropTypes.string,
  isMultiLineDescription: PropTypes.bool,

  showCallToAction: PropTypes.bool,
  callToAction: PropTypes.string,

  showAdLabel: PropTypes.bool,
  showGradient: PropTypes.bool,

  showAdInfoLabel: PropTypes.bool,
  isAdInfoLabelWithText: PropTypes.bool,

  showRating: PropTypes.bool,
  ratingPoint: PropTypes.number,
  maxPoint: PropTypes.number,
  showRatingPoint: PropTypes.bool,
  ratingComment: PropTypes.string,

  showPlayIcon: PropTypes.bool,

  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({
    placementCard: PropTypes.string,
    placementImageContainer: PropTypes.string,
    placementTextContainer: PropTypes.string,
    placementAdsLabel: PropTypes.string,
    placementShortHeadline: PropTypes.string,
    placementLongHeadline: PropTypes.string,
    placementDescription: PropTypes.string,
    placementCallToAction: PropTypes.string,
    playIconContainer: PropTypes.string,
    adInfoLabel: PropTypes.string,
    placementGradient: PropTypes.string,
  }).isRequired,
};

ImageAdPlacementBase.defaultProps = {
  customClassName: '',
  imagePreviewHeight: -1,

  showShortHeadline: false,
  showLongHeadline: false,
  showDescription: false,
  showCallToAction: false,
  showAdLabel: false,
  showGradient: false,
  showAdInfoLabel: false,
  isAdInfoLabelWithText: false,
  showRating: false,
  showRatingPoint: false,
  showPlayIcon: false,

  ratingPoint: 5,
  maxPoint: 5,

  shortHeadline: undefined,
  isMultiLineShortHeadline: false,
  longHeadline: undefined,
  isMultiLineLongHeadline: false,
  finalUrl: undefined,
  description: undefined,
  isMultiLineDescription: false,
  callToAction: undefined,
  ratingComment: undefined,
};
